/**
 * RestrictedSignupClosed — placeholder shown at /signup/:slug while
 * external public signup for restricted states is disabled.
 *
 * Background:
 *   /signup/:slug was the iter53 public-signup entry point for
 *   restricted-state communities. As of iter153 we route ALL
 *   restricted-state user provisioning through ORB (JWT-ticket SSO
 *   at /u/:universe_id/signin), so the public signup serves no
 *   purpose and is hidden from external visitors. We keep the route
 *   mounted (rather than 404ing) so any old bookmarks / printed
 *   QR codes from earlier iterations land on a polite "this is
 *   by-invitation" notice instead of a confusing generic 404.
 *
 * When ORB wants to re-enable direct external signup for a state
 * (e.g. an admin invite flow), App.js swaps this element back to
 * <RestrictedSignupPage />.
 */
import React from 'react';

export default function RestrictedSignupClosed() {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-b from-[#d4e4cf] via-[#e8ede6] to-[#c9d4c3]"
      data-testid="restricted-signup-closed"
    >
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-lg p-8 text-center space-y-4">
        {/* iter153 — visually tightened: ORB letterform sits just above
            the Uplift wordmark so it reads as a single "ORB Uplift"
            lockup, matching the AuthPage header exactly. */}
        <div className="mx-auto w-16 h-12 flex items-center justify-center overflow-hidden translate-y-1">
          <img src="/login-orb-logo.png" alt="ORB" className="w-full h-full object-contain" />
        </div>
        <h1
          className="text-3xl font-bold text-gray-900 tracking-tight"
          style={{ transform: 'translateY(-18px)' }}
        >
          Uplift
        </h1>
        <div className="pt-2">
          <p className="text-base text-gray-700 font-medium">By invitation only</p>
          <p className="text-sm text-gray-500 mt-3 leading-relaxed">
            ORB Uplift is provisioned through your ORB community.
            Please sign in to your ORB account to access Uplift.
          </p>
        </div>
        <div className="pt-4">
          <a
            href="https://www.collectiveorb.com"
            className="inline-block px-6 py-2 bg-[#586D52] text-white rounded-lg text-sm font-medium hover:bg-[#475a43] transition-colors"
            data-testid="restricted-signup-closed-orb-link"
          >
            Go to ORB
          </a>
        </div>
      </div>
    </div>
  );
}
